export default "__VITE_ASSET__DFILptcy__"